// utils/constants.ts
import { IN, OUT, NOTYET } from "../../../utils/Constant";

export const PRIVILEGED_IDS = [1, 29, 1609] as const;

export const ADMIN_HR_ROLES = ["admin", "hr"] as const;
export const MANAGER_ROLE = "manager";

export const ATTENDANCE_IN = IN;
export const ATTENDANCE_OUT = OUT;
export const ATTENDANCE_NOT_YET = NOTYET;

export const JOB_TYPE_MAP: Record<string, string> = {
  full_time: "Full Time",
  support_staff: "Support Staff",
  consultant: "Consultant",
  intern: "Intern",
};
